import {Modal} from "react-bootstrap";
import MDButton from "../../components/MDButton";
import QRCode from "react-qr-code";
import {formatCurrency} from "../common/Utils";
import {useContext, useEffect, useState} from "react";
import {AppContext} from "../../lib/AppContext";
import PrintIcon from '@mui/icons-material/Print';
import {ButtonGroup} from "@mui/material";
import ListCustomersResults from "./ListCustomersResults";
import {Send} from "@mui/icons-material";
import {transferCustomerGiftCard} from "../common/api/CustomerProfileApi";
import GiftCardBody from "./GiftCardBody";
import {CompanyContext} from "../../lib/CompanyContext";

export default function GiftCardQrCode({giftCard, show, handleClose}) {
  const [context, setContext] = useContext(AppContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [giftCardUrl, setGiftCardUrl] = useState('');
  useEffect(() => {
    setGiftCardUrl(context?.sessionUser?.company?.portalUrl + '#/cx/gift-card/' + giftCard?.guid)
  }, [context]);

  const [transferGiftCard, setTransferGiftCard] = useState(false);

  const startTransferGiftCard = () => {
    setTransferGiftCard(true);
  }

  const printGiftCard = () => {
    const content = document.getElementById("gift-card").innerHTML;
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
                                              <html>
                                              <head>
                                                  <title>Print</title>
                                                  <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; font-size:0.9rem; line-height:0.9rem; }
                                                      p{margin:0; padding:0; line-height:13px; font-size:12px;}
                                                      h1,h2,h3,h4,h5,h6{font-size:14px; margin:0; padding:0; line-height:15px}
                                                      .no-print { display: none !important; }
                                                      body * {
                                                       max-width: 96%
                                                      }
                                                  </style>
                                              </head>
                                              <body onload="window.print(); window.close();">
                                                   ${content}
                                              </body>
                                              </html>
                                            `);
    printWindow.document.close();
  }

  let giftCardBackgroundStyles = 'repeating-linear-gradient(45deg, white 0 10px, #eee 10px 20px) ';
  if (giftCard.backgroundImageUrl) {
    giftCardBackgroundStyles = "url('" + giftCard.backgroundImageUrl + "') no-repeat center/cover ";
  }

  const actionFn = (customer) => {
    transferCustomerGiftCard(customer, giftCard).then((resp)=>{
      let _context = {...context};
      _context.reloadCart = true;
      _context.toast = {
        message: 'Gift Card Transferred',
        type: 'success'
      }
      setContext({..._context});
      handleClose('refresh');
    });
  }

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Gift Card</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{
        background: transferGiftCard ? 'inherit' : '#efefef'
      }}>

        {transferGiftCard && <>
          <ListCustomersResults
            hiddenColumns={['lastVisit', 'referral', 'referral', 'familyMembers']}
            actionLabel={'Transfer'}
            embedded={true}
            action={actionFn}
          />
        </>
        }
        {!transferGiftCard && <>
          <div id={'gift-card'}>
            <GiftCardBody backgroundStyle={{
              background: giftCardBackgroundStyles
            }}
                          giftCardRecipient={giftCard.giftCardRecipient}
                          giftCardFrom={giftCard.from}
                          giftCardBalance={giftCard.currentBalance}
                          giftCardQrCode={<QRCode
                            size={256}
                            style={{height: "auto", maxWidth: "100%", width: "100%"}}
                            value={giftCardUrl}
                            viewBox={'0 0 256 256'}/>}
                          companyName={companyContext?.company?.companyName}
                          giftCardMessage={giftCard.giftCardMessage}
                          giftCardCode={giftCard.transferCode}
                          giftCardLink={giftCardUrl}/>
          </div>
          <hr/>

          <ButtonGroup>
            <MDButton type="button" color="primary" size={"small"} className={'my-3'} onClick={() => {
              printGiftCard()
            }}>
              <PrintIcon/>&nbsp;Print
            </MDButton>
            <MDButton type="button" color="secondary" size={"small"} className={'my-3'} onClick={() => {
              startTransferGiftCard()
            }}>
              <Send /> &nbsp;Transfer
            </MDButton>
          </ButtonGroup>
        </>}

      </Modal.Body>

      <Modal.Footer>

        <MDButton type="button" color="info" onClick={() => {
          handleClose()
        }}>
          Close
        </MDButton>
      </Modal.Footer>
    </Modal>
  );
}